<template>
    <CustomSelectOne :name="name" :label="label" :items="items"
                     itemValue="value" :emptyValue="emptyValue"
                     v-model="internalValue" :disabled="disabled"
                     :required="required" :noPlaceholder="noPlaceholder"/>
</template>

<script>
    import CustomSelectOne from "./inner/CustomSelectOne";

    export default {
        name: "CustomSelectOneYesNo",

        components: {CustomSelectOne},

        props: {
            name: {
                type: String,
            },
            label: {
                type: String,
            },
            emptyValue: {
                type: Boolean,
                default: false,
            },
            modelValue: null,
            disabled: {
                type: Boolean,
                default: false,
            },
            required: {
                type: Boolean,
                default: false,
            },
            noPlaceholder: {
                type: Boolean,
                default: false,
            },
        },

        emits: ["update:modelValue"],

        computed: {
            internalValue: {
                get() {
                    return this.modelValue;
                },
                set(value) {
                    this.$emit("update:modelValue", value);
                },
            },
        },

        data() {
            return {
                items: [
                    {
                        label: "Yes",
                        value: true,
                    },
                    {
                        label: "No",
                        value: false,
                    },
                ],
            };
        },
    };
</script>

<style lang="scss">
</style>
